/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: ZAZdkBbdpT7a
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import SeparatorHorizontal from "../../SeparatorHorizontal"; // plasmic-import: vjwl8iKCk0Vg/component
import BottomNav from "../../BottomNav"; // plasmic-import: KUFcRsF9ovEF/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import OnboardingContainer from "../../OnboardingContainer"; // plasmic-import: KM-5MN7o_pvE/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: hEgWOAymJgYc/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: e3sNvwGa9YkJ/component
import FormElement from "../../FormElement"; // plasmic-import: SrXOXPt7amu2/component
import InputField from "../../InputField"; // plasmic-import: Vlgv2YqSKmv3/component
import RadioGroup from "../../RadioGroup"; // plasmic-import: VO3s6GsnNRnj/component
import RadioOption from "../../RadioOption"; // plasmic-import: k7E8qopXsZkS/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicWebSignupTemp.module.css"; // plasmic-import: ZAZdkBbdpT7a/css
import image183TIq2GJx3VUp from "./images/image18.svg"; // plasmic-import: 3tIq2GJx3vUP/picture
import image2RcDhf2RmVmG from "./images/image2.svg"; // plasmic-import: RcDhf_2RMVmG/picture

createPlasmicElementProxy;

export const PlasmicWebSignupTemp__VariantProps = new Array();

export const PlasmicWebSignupTemp__ArgProps = new Array();

const $$ = {};

function PlasmicWebSignupTemp__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "insideOnboarding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.insideOnboarding
      },
      {
        path: "onboardingContainer.showTerms",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "onboardingContainer.container",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "withForm"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"page"}
        data-plasmic-override={overrides.page}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.page
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <TabLayout
              data-plasmic-name={"tabLayout"}
              data-plasmic-override={overrides.tabLayout}
              className={classNames("__wab_instance", sty.tabLayout)}
              layoutType={"verticalStacked"}
              tabContent={
                <PageLayout
                  data-plasmic-name={"pageLayout"}
                  data-plasmic-override={overrides.pageLayout}
                  className={classNames("__wab_instance", sty.pageLayout)}
                  layoutSections={"withoutNav"}
                  pageContent={
                    <OnboardingContainer
                      data-plasmic-name={"onboardingContainer"}
                      data-plasmic-override={overrides.onboardingContainer}
                      buttonsWrapper={
                        <React.Fragment>
                          <ButtonPrimary
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPrimary__gKcDb
                            )}
                            color={"brand"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPWorkspace"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/platform/workspace`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPWorkspace"] != null &&
                                typeof $steps["goToPWorkspace"] === "object" &&
                                typeof $steps["goToPWorkspace"].then ===
                                  "function"
                              ) {
                                $steps["goToPWorkspace"] =
                                  await $steps["goToPWorkspace"];
                              }
                            }}
                          />

                          {false ? (
                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary__d8LIf
                              )}
                            />
                          ) : null}
                        </React.Fragment>
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.onboardingContainer
                      )}
                      container={generateStateValueProp($state, [
                        "onboardingContainer",
                        "container"
                      ])}
                      formWrapper={
                        <InputFormShell
                          data-plasmic-name={"inputFormShell"}
                          data-plasmic-override={overrides.inputFormShell}
                          actionsSlot={
                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary__xVwpC
                              )}
                              color={"brand"}
                              content={"notify me"}
                              name={``}
                              showIcon={false}
                              size={"medium"}
                              ststus={"normal"}
                              type={"button"}
                            />
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.inputFormShell
                          )}
                          fieldsSlot={
                            <React.Fragment>
                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement__yq1NM
                                )}
                                formInputComponent={
                                  <InputField
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputField__crnyg
                                    )}
                                    placeholder={``}
                                    status={"normal"}
                                    type={"text"}
                                  />
                                }
                                helperText={``}
                                label={"*first name."}
                                name={``}
                                required={true}
                                showHelperText={false}
                                status={"normal"}
                              />

                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement___2Hn2I
                                )}
                                formInputComponent={
                                  <InputField
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputField__cheuL
                                    )}
                                    placeholder={``}
                                    status={"normal"}
                                    type={"text"}
                                  />
                                }
                                helperText={``}
                                label={"*last name."}
                                name={``}
                                required={true}
                                showHelperText={false}
                                status={"normal"}
                              />

                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement__gYdeR
                                )}
                                formInputComponent={
                                  <InputField
                                    className={classNames(
                                      "__wab_instance",
                                      sty.inputField__apq8D
                                    )}
                                    placeholder={``}
                                    status={"normal"}
                                    type={"email"}
                                  />
                                }
                                helperText={``}
                                label={"*email."}
                                name={``}
                                required={true}
                                showHelperText={false}
                                status={"normal"}
                              />

                              <FormElement
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement__fzla1
                                )}
                                formInputComponent={
                                  <RadioGroup
                                    data-plasmic-name={"radioGroup"}
                                    data-plasmic-override={overrides.radioGroup}
                                    className={classNames(
                                      "__wab_instance",
                                      sty.radioGroup
                                    )}
                                    radioOptionsSlot={
                                      <React.Fragment>
                                        <RadioOption
                                          className={classNames(
                                            "__wab_instance",
                                            sty.radioOption__xb74H
                                          )}
                                          valueShown={"Yes."}
                                        />

                                        <RadioOption
                                          className={classNames(
                                            "__wab_instance",
                                            sty.radioOption__mdwcj
                                          )}
                                          valueShown={"No."}
                                        />
                                      </React.Fragment>
                                    }
                                  />
                                }
                                helperText={``}
                                label={"*are you a licensed clinician?"}
                                name={``}
                                required={true}
                                showHelperText={false}
                                status={"normal"}
                              />

                              <div
                                data-plasmic-name={"wrapper"}
                                data-plasmic-override={overrides.wrapper}
                                className={classNames(
                                  projectcss.all,
                                  sty.wrapper
                                )}
                              >
                                <FormElement
                                  className={classNames(
                                    "__wab_instance",
                                    sty.formElement___89Ebj
                                  )}
                                  formInputComponent={
                                    <InputField
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputField__tasbk
                                      )}
                                      placeholder={'"Dr."'}
                                      status={"normal"}
                                      type={"text"}
                                    />
                                  }
                                  helperText={``}
                                  label={"title."}
                                  name={``}
                                  required={false}
                                  showHelperText={false}
                                  status={"normal"}
                                />

                                <FormElement
                                  className={classNames(
                                    "__wab_instance",
                                    sty.formElement__rQtYv
                                  )}
                                  formInputComponent={
                                    <InputField
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputField__h2PHn
                                      )}
                                      placeholder={'"DDS", "DDM"'}
                                      status={"normal"}
                                      type={"text"}
                                    />
                                  }
                                  helperText={``}
                                  label={"credentials."}
                                  name={``}
                                  required={false}
                                  showHelperText={false}
                                  status={"normal"}
                                />
                              </div>
                            </React.Fragment>
                          }
                          layout={"_default"}
                          onSubmit={async () => {
                            const $steps = {};
                          }}
                        />
                      }
                      infotextWrapper2={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__t2QjC
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {"Already have an account? "}
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-jyNQAasUGv4X)" }}
                            >
                              {"[ "}
                            </span>
                            <React.Fragment>{""}</React.Fragment>
                            {
                              <PlasmicLink__
                                data-plasmic-name={"link"}
                                data-plasmic-override={overrides.link}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.a,
                                  projectcss.__wab_text,
                                  projectcss.plasmic_default__inline,
                                  sty.link
                                )}
                                href={`/login`}
                                platform={"react"}
                              >
                                <React.Fragment>
                                  <span
                                    className={
                                      "plasmic_default__all plasmic_default__span"
                                    }
                                    style={{
                                      color: "var(--token-jyNQAasUGv4X)"
                                    }}
                                  >
                                    {"log in"}
                                  </span>
                                </React.Fragment>
                              </PlasmicLink__>
                            }
                            <React.Fragment>{""}</React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-jyNQAasUGv4X)" }}
                            >
                              {" ]"}
                            </span>
                          </React.Fragment>
                        </div>
                      }
                      onContainerChange={async (...eventArgs) => {
                        generateStateOnChangeProp($state, [
                          "onboardingContainer",
                          "container"
                        ]).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      onShowTermsChange={async (...eventArgs) => {
                        generateStateOnChangeProp($state, [
                          "onboardingContainer",
                          "showTerms"
                        ]).apply(null, eventArgs);
                        if (
                          eventArgs.length > 1 &&
                          eventArgs[1] &&
                          eventArgs[1]._plasmic_state_init_
                        ) {
                          return;
                        }
                      }}
                      showHelperText={true}
                      showTerms={generateStateValueProp($state, [
                        "onboardingContainer",
                        "showTerms"
                      ])}
                      stepHeader={
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__uSeIu
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ color: "var(--token-OWCwjNMz5wK-)" }}
                            >
                              {"we\u2019re still working on it."}
                            </span>
                            <React.Fragment>
                              {
                                "\nleave your details and we\u2019ll let you know when it\u2019s ready."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </div>
                      }
                      text={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___7HyPr
                            )}
                          >
                            <React.Fragment>
                              <React.Fragment>
                                {"We\u2019ve sent a message with a link to "}
                              </React.Fragment>
                              <span
                                className={
                                  "plasmic_default__all plasmic_default__span"
                                }
                                style={{ color: "#000000", fontWeight: 600 }}
                              >
                                {"john@email.com"}
                              </span>
                              <React.Fragment>
                                {" to verify your email."}
                              </React.Fragment>
                            </React.Fragment>
                          </div>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___0Z4Wy
                            )}
                          >
                            {
                              "This link expires in 24 hours.\nDidn't receive an email? Check your spam folder."
                            }
                          </div>
                        </React.Fragment>
                      }
                      text2={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__uzm0X
                            )}
                          >
                            {"that\u2019s it, you\u2019re in."}
                          </div>
                          {false ? (
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__n0Twl
                              )}
                            >
                              {
                                "You\u2019ve successfully created you OP account."
                              }
                            </div>
                          ) : null}
                        </React.Fragment>
                      }
                    />
                  }
                />
              }
              tabNav={
                <React.Fragment>
                  <SeparatorHorizontal
                    data-plasmic-name={"separatorHorizontal"}
                    data-plasmic-override={overrides.separatorHorizontal}
                    className={classNames(
                      "__wab_instance",
                      sty.separatorHorizontal
                    )}
                  />

                  <BottomNav
                    data-plasmic-name={"bottomNav"}
                    data-plasmic-override={overrides.bottomNav}
                    className={classNames("__wab_instance", sty.bottomNav)}
                    nameWrapper={
                      <LeftSectionNav
                        data-plasmic-name={"leftSectionTopnav"}
                        data-plasmic-override={overrides.leftSectionTopnav}
                        bottomNav={"defaultOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.leftSectionTopnav
                        )}
                        topNav={"tabTitle"}
                      >
                        {"create your OP workspace account."}
                      </LeftSectionNav>
                    }
                    navModule={
                      <ModuleNav
                        byPlacement={"navOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.moduleNav___7Q1Jf
                        )}
                        navButtonSlot={
                          <ButtonNav
                            className={classNames(
                              "__wab_instance",
                              sty.buttonNav__v44Ak
                            )}
                            color={"greyTwo"}
                            iconForButton={
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img___8TlXt)}
                                displayHeight={"100%"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"none"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"100%"}
                                loading={"lazy"}
                                src={{
                                  src: image183TIq2GJx3VUp,
                                  fullWidth: 20,
                                  fullHeight: 20,
                                  aspectRatio: undefined
                                }}
                              />
                            }
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToWebHome"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/home` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToWebHome"] != null &&
                                typeof $steps["goToWebHome"] === "object" &&
                                typeof $steps["goToWebHome"].then === "function"
                              ) {
                                $steps["goToWebHome"] =
                                  await $steps["goToWebHome"];
                              }
                            }}
                            shape={"globalRounding"}
                            status={"normal"}
                          />
                        }
                      />
                    }
                    navModule2={
                      <ModuleNav
                        byPlacement={"navOnboarding"}
                        className={classNames(
                          "__wab_instance",
                          sty.moduleNav___6VUkQ
                        )}
                        navButtonSlot={
                          <ButtonNav
                            className={classNames(
                              "__wab_instance",
                              sty.buttonNav__tCncv
                            )}
                            iconForButton={
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__fHy8B)}
                                displayHeight={"100%"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"none"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"100%"}
                                loading={"lazy"}
                                src={{
                                  src: image2RcDhf2RmVmG,
                                  fullWidth: 256,
                                  fullHeight: 256,
                                  aspectRatio: 1
                                }}
                              />
                            }
                            shape={"fullRounding"}
                            slotSize={"fillButton"}
                          />
                        }
                      />
                    }
                    type={"withRightModule"}
                  />
                </React.Fragment>
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  page: [
    "page",
    "appShell",
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  tabLayout: [
    "tabLayout",
    "separatorHorizontal",
    "bottomNav",
    "leftSectionTopnav",
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  separatorHorizontal: ["separatorHorizontal"],
  bottomNav: ["bottomNav", "leftSectionTopnav"],
  leftSectionTopnav: ["leftSectionTopnav"],
  pageLayout: [
    "pageLayout",
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  onboardingContainer: [
    "onboardingContainer",
    "inputFormShell",
    "radioGroup",
    "wrapper",
    "link"
  ],

  inputFormShell: ["inputFormShell", "radioGroup", "wrapper"],
  radioGroup: ["radioGroup"],
  wrapper: ["wrapper"],
  link: ["link"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSignupTemp__ArgProps,
          internalVariantPropNames: PlasmicWebSignupTemp__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSignupTemp__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "page") {
    func.displayName = "PlasmicWebSignupTemp";
  } else {
    func.displayName = `PlasmicWebSignupTemp.${nodeName}`;
  }
  return func;
}

export const PlasmicWebSignupTemp = Object.assign(
  // Top-level PlasmicWebSignupTemp renders the root element
  makeNodeComponent("page"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    separatorHorizontal: makeNodeComponent("separatorHorizontal"),
    bottomNav: makeNodeComponent("bottomNav"),
    leftSectionTopnav: makeNodeComponent("leftSectionTopnav"),
    pageLayout: makeNodeComponent("pageLayout"),
    onboardingContainer: makeNodeComponent("onboardingContainer"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    radioGroup: makeNodeComponent("radioGroup"),
    wrapper: makeNodeComponent("wrapper"),
    link: makeNodeComponent("link"),
    // Metadata about props expected for PlasmicWebSignupTemp
    internalVariantProps: PlasmicWebSignupTemp__VariantProps,
    internalArgProps: PlasmicWebSignupTemp__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP | signup.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicWebSignupTemp;
/* prettier-ignore-end */
